var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.amount)?_c('div',{staticClass:"item",class:_vm.style},[_c('div',{staticClass:"item-name"},[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.amount)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }